<template>
<!-- 确认投保页面 -->
  <div class="overflowHidden">
    <div class="backImg boxShadow mar10 padd10 borderRadius8 overflowHidden size14 color21 lineH20">
      <div class="size16 font600 Yflex">
        {{quoteVehicleInfo.vehicleInfo.plateNo?quoteVehicleInfo.vehicleInfo.plateNo:'新车无牌'}}
        <i class="fraction marLeft14" v-if="quoteVehicleInfo.confirmQuotation && quoteVehicleInfo.confirmQuotation.centile">{{quoteVehicleInfo.confirmQuotation.centile.split('.')[0]}}<span v-if="quoteVehicleInfo.confirmQuotation.centile.split('.')[1] > 0">{{quoteVehicleInfo.confirmQuotation.centile.split('.')[1]}}</span>分</i>
      </div>
      <div class="flex marTop10">
        <span>使用性质</span><span class="marLeft10">{{quoteVehicleInfo.vehicleInfo.usageAttribute | usageAttributeTran }}</span>
      </div>
      <div class="marTop10 flex">车辆识别代号<span class="flex1 marLeft10">{{quoteVehicleInfo.vehicleInfo.vehicleFrameNo}}</span></div>
      <div class="marTop10 flex">发动机号<span class="flex1 marLeft10">{{quoteVehicleInfo.vehicleInfo.engineNo}}</span></div>
      <div class="marTop10 flex">初登日期<span class="flex1 marLeft10">{{quoteVehicleInfo.vehicleInfo.firstRegisterDate | wq_capitalize('yyyy-MM-dd')}}</span></div>
      <div class="marTop10 flex">
        <div class="widthPercent40 flex">是否过户 <span class="marLeft10">{{quoteVehicleInfo.vehicleInfo.transferFlag == 1?"是":"否"}}</span>
        </div>
        <div v-if="quoteVehicleInfo.vehicleInfo.transferFlag == 1" class="flex1 flex">过户日期<span class="marLeft10">{{quoteVehicleInfo.vehicleInfo.transferDate | wq_capitalize('yyyy-MM-dd')}}</span>
        </div>
      </div>
      <div class="marTop10 flex"><span>品牌型号</span><span class="marLeft10 flex1">{{quoteVehicleInfo.vehicleInfo.modelName}}</span></div>
    </div>
    <div class="marLR10 padd10 borderRadius8 overflowHidden size14 color66 backF lineH20">
     <h3 class="XYcenter XsbYcenter paddBott10" :class="insuranceBool ? 'paddBott10':''">
       <span class="size16 font600 color21">保司平台信息</span>
       <span class="pointer color99" @click="insuranceBool = !insuranceBool">{{insuranceBool ? '收起' : '展开' }} <i class="van-icon" :class="insuranceBool ? 'van-icon-arrow-up':'van-icon-arrow-down'"></i></span>
     </h3>
      <div v-if="quoteVehicleInfo.confirmQuotation && quoteVehicleInfo.confirmQuotation.factors && insuranceBool" class="flex flexWrap borderTopF5">
        <div class="flex marTop10" style="min-width:50%;" v-for="(item,i) in Object.entries(JSON.parse(quoteVehicleInfo.confirmQuotation.factors))" :key="i">
          <div v-html="item[0]"></div><div class="marLeft10 color21 flex1" v-html="item[1]"></div>
        </div>
        <div class="flex marTop10" style="min-width:50%;" v-if="quoteVehicleInfo.confirmQuotation && quoteVehicleInfo.confirmQuotation.centile">
          车辆评分
          <span class="marLeft10 color21 flex1">{{quoteVehicleInfo.confirmQuotation.centile.split('.')[0]}}<span v-if="quoteVehicleInfo.confirmQuotation.centile.split('.')[1] > 0">{{quoteVehicleInfo.confirmQuotation.centile.split('.')[1]}}</span></span>
        </div>
      </div>
    </div>

    <!-- 投保基本信息 -->
    <div class="marLR10 padd10 borderRadius8 overflowHidden size14 backF marTop10">
      <div class="size16 color21 font600 paddBott10">投保信息</div>
      <!-- 车主信息 -->
      <h3 class="font600 color21 borderTopF5 paddBott10 paddTop8">车主信息</h3>
      <ul class="infoList color21 paddBott10">
        <li class="flex">
          <span class="color66 width100 marRight4">名称</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.ownerName}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">证件类型</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.ownerIdentityType | identityType}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">证件号</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.ownerIdentityNo}}</span>
        </li>
      </ul>
      <!-- 投保人信息 -->
      <h3 class="font600 color21 borderTopF5 paddBott10 paddTop8">投保人信息</h3>
      <ul class="infoList color21 paddBott10">
        <li class="flex">
          <span class="color66 width100 marRight4">名称</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.phName}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">证件类型</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.phIdentityType | identityType}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">证件号</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.phIdentityNo}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">联系电话</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.phTelNo}}</span>
        </li>
        <li class="flex marTop10" v-if="quoteVehicleInfo.personInfo.phContactName && quoteVehicleInfo.personInfo.phIdentityType==5">
          <span class="color66 width100 marRight4">经办人</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.phContactName}}</span>
        </li>
        <li class="flex marTop10" v-if="quoteVehicleInfo.personInfo.phContactName && quoteVehicleInfo.personInfo.phIdentityType==5">
          <span class="color66 width100 marRight4">经办人证件号</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.phContactIdentityNo}}</span>
        </li>
        <li class="flex marTop10" v-if="quoteVehicleInfo.personInfo.phContactName && quoteVehicleInfo.personInfo.phIdentityType==5">
          <span class="color66 width100 marRight4">经办人联系电话</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.phContactTelNo}}</span>
        </li>
      </ul>
      <!-- 被保人信息 -->
      <h3 class="font600 color21 borderTopF5 paddBott10 paddTop8">被保人信息</h3>
      <ul class="infoList color21 paddBott10">
        <li class="flex">
          <span class="color66 width100 marRight4">名称</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.insuredName}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">证件类型</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.insuredIdentityType | identityType}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">证件号</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.insuredIdentityNo}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">联系电话</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.insuredTelNo}}</span>
        </li>
        <li class="flex marTop10" v-if="quoteVehicleInfo.personInfo.insuredContactName && quoteVehicleInfo.personInfo.insuredIdentityType==5">
          <span class="color66 width100 marRight4">经办人</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.insuredContactName}}</span>
        </li>
        <li class="flex marTop10" v-if="quoteVehicleInfo.personInfo.insuredContactName && quoteVehicleInfo.personInfo.insuredIdentityType==5">
          <span class="color66 width100 marRight4">联系人证件号</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.insuredContactIdentityNo}}</span>
        </li>
        <li class="flex marTop10" v-if="quoteVehicleInfo.personInfo.insuredContactName && quoteVehicleInfo.personInfo.insuredIdentityType==5">
          <span class="color66 width100 marRight4">经办人联系电话</span>
          <span class="flex1">{{quoteVehicleInfo.personInfo.insuredContactTelNo}}</span>
        </li>
      </ul>
    </div>
    <div class="backF marLR10 paddLR10 paddBott10 borderRadius8 overflowHidden marTop10" v-if="quoteVehicleInfo.confirmQuotation">
      <!-- 投保基本信息 -->
      <div class="relative XsbYcenter productLogoBox">
        <img class="productLogo" :src="baseApi + quoteVehicleInfo.confirmProduct.productLogo" alt="">
        <div class="color99 size14">合计保费<span class="moneyColor size16">￥{{quoteVehicleInfo.confirmQuotation.totalAmount}}</span></div>
        <div class="productTips" v-if="syxRenewal || jqxRenewal">{{ jqxRenewal }}{{ syxRenewal }}</div>
      </div>
      <div class="size12 marTop10 XYcenter XsbYcenter"  v-if="quoteVehicleInfo.confirmQuotation.trafficAmount">
        <span class="color66">交强险保险期限</span>
        <span>{{quoteVehicleInfo.confirmQuotation.trafficStartTime }}至{{quoteVehicleInfo.confirmQuotation.trafficEndTime}}</span>
      </div>
      <div class="size12 marTop10 XYcenter XsbYcenter"  v-if="quoteVehicleInfo.confirmQuotation.commercialAmount">
        <span class="color66">商业险保险期限</span>
        <span>{{quoteVehicleInfo.confirmQuotation.commercialStartTime}}至{{quoteVehicleInfo.confirmQuotation.commercialEndTime}}</span>
      </div>
      <div class="size12 marTop10 XYcenter XsbYcenter"  v-if="quoteVehicleInfo.underwritingVO.jqxApplyPolicyNo">
        <span class="color66">交强险投保单号</span>
        <span>{{quoteVehicleInfo.underwritingVO.jqxApplyPolicyNo }}  | <em  class="pointer" id="copyBtn" ref="copyBtn" :data-clipboard-text="quoteVehicleInfo.underwritingVO.jqxApplyPolicyNo"  @click="copyFn('copyBtn')">复制</em></span>
      </div>
      <div class="size12 marTop10 XYcenter XsbYcenter"  v-if="quoteVehicleInfo.underwritingVO.syxApplyPolicyNo">
        <span class="color66">商业险投保单号</span>
        <span>{{quoteVehicleInfo.underwritingVO.syxApplyPolicyNo}} | <em class="pointer" id="copyBtn2" ref="copyBtn2" :data-clipboard-text="quoteVehicleInfo.underwritingVO.syxApplyPolicyNo"  @click="copyFn('copyBtn2')">复制</em></span>
      </div>
      <div class="XsbYcenter paddTop14 paddBott10 size14" v-if="quoteVehicleInfo.policyInfoVO && quoteVehicleInfo.policyInfoVO.jqxPolicyNo">
        <span class="color66">交强险保单号</span>
        <span >{{quoteVehicleInfo.policyInfoVO.jqxPolicyNo || ''}} | <em class="pointer" id="copyBtn3" ref="copyBtn3" :data-clipboard-text="quoteVehicleInfo.policyInfoVO.jqxPolicyNo"  @click="copyFn('copyBtn3')">复制</em></span>
      </div>

      <div v-if="quoteVehicleInfo.policyInfoVO && quoteVehicleInfo.policyInfoVO.syxPolicyNo" class="XsbYcenter  paddBott10 size14" :class="{'paddTop14': !quoteVehicleInfo.policyInfoVO.jqxPolicyNo}" >
        <span class="color66">商业险保单号</span>
        <span>{{quoteVehicleInfo.policyInfoVO.syxPolicyNo || ''}} | <em class="pointer" id="copyBtn4" ref="copyBtn4" :data-clipboard-text="quoteVehicleInfo.policyInfoVO.syxPolicyNo"  @click="copyFn('copyBtn4')">复制</em></span>
      </div>
      <div class="XsbYcenter borderTopF5 marTop10 paddTop14 paddBott10" v-if="quoteVehicleInfo.confirmQuotation.trafficAmount">
        <div class="relative size16 font600">交强险
          <span class="tipsBox " v-if="quoteVehicleInfo.confirmQuotation.jqxDiscount>0">{{quoteVehicleInfo.confirmQuotation.jqxDiscount}}</span>
        </div>
        <span class="moneyColor">￥{{quoteVehicleInfo.confirmQuotation.trafficAmount}}</span>
      </div>
      <div class=" paddTop14 paddBott10 borderTopF5" v-if="quoteVehicleInfo.confirmQuotation.taxAmount">
        <div class="XsbYcenter paddBott10">
          <span class="size16 font600">车船税</span>
          <span class="moneyColor">￥{{quoteVehicleInfo.confirmQuotation.taxAmount}}</span>
        </div>
        <div class="size14 backF5 paddLR10 paddBott10 color66" v-if="quoteVehicleInfo.confirmQuotation.taxDetails && quoteVehicleInfo.confirmQuotation.taxDetails.length > 0">
          <div class=" overflowHidden" v-for="(item, i) in JSON.parse(quoteVehicleInfo.confirmQuotation.taxDetails)"  :key="i" >
            <div class=" XsbYcenter marTop10">
              <span>{{year[item.taxAnnualType]}}</span>
              <span>{{ item.totalAmount-item.overDue }}元</span>
            </div>
            <div class=" XsbYcenter marTop10" v-if="item.exceedDaysCount > 1">
              <span>滞纳金</span>
              <span>{{ item.overDue }}元</span>
            </div>
          </div>
        </div>
      </div>
      <div class="borderTopF5 paddTop14 paddBott10" v-if="quoteVehicleInfo.confirmQuotation.commercialAmount">
        <div class="XsbYcenter">
          <div class="relative size16 font600">商业险<span class="tipsBox " v-if="quoteVehicleInfo.confirmQuotation.syxDiscount>0">{{quoteVehicleInfo.confirmQuotation.syxDiscount}}</span>
          </div>
          <span class="moneyColor">￥{{quoteVehicleInfo.confirmQuotation.commercialAmount}}</span>
        </div>
        <div class="backF5 padd10 marTop10 borderRadius4" v-if="quoteVehicleInfo.confirmQuotation.vehicleCoverVOLs.length > 0">
          <div class="size14 XsbYcenter">
            <span class="widthPercent46">险别</span>
            <span  class="widthPercent27">保额(元)</span>
            <span class="textRight widthPercent27">保费(元)</span>
          </div>
          <div v-for="item in quoteVehicleInfo.confirmQuotation.vehicleCoverVOLs" :key="item.coverCode" v-if="item.coverType =='SYX'">
            <div class="marTop10 size14 color66 XsbYcenter" >
              <span class="widthPercent46">{{ item.coverName }}</span>
              <span class="widthPercent27" :class="((item.coverType != 'P_01' || item.coverType == 'C_20' || item.coverType == 'C_21' || item.coverType == 'C_22' || item.coverType == 'C_23')  && item.offeDetailAmout  && item.offeDetailAmout != 0) ? '':'textRight'">{{item.premium | premiumStr(item.coverCode,item.seats,item.fixDays)}}</span>
              <span class="widthPercent27 textRight" v-if="(item.coverType != 'P_01' || item.coverType == 'C_20' || item.coverType == 'C_21' || item.coverType == 'C_22' || item.coverType == 'C_23') && item.offeDetailAmout  && item.offeDetailAmout != 0"><i >{{ item.offeDetailAmout  }}</i></span>
            </div>
            <div class="marTop10 size14 color66 XsbYcenter forcibly" v-if="item.coverCode == 'C_01' && item.enoughPremium">
              <span class="widthPercent46">车损绝对免赔额</span>
              <span class="widthPercent27">{{ item.enoughPremium }}</span>
              <span class="widthPercent27 textRight"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="paddTop14 borderTopF5 paddBott10" v-if="quoteVehicleInfo.confirmQuotation.wealthPrice">
        <div class="XsbYcenter">
          <span class="size16 font600">财意险</span>
          <span class="moneyColor">￥{{quoteVehicleInfo.confirmQuotation.wealthPrice}}</span>
        </div>
        <div v-for="(item,i) in quoteVehicleInfo.confirmQuotation.vehicleCoverVOLs" :key="i">
          <div v-if="item.className && item.coverType != 'P_04'" class="size14">
            <div class="paddTop10 flex lineH20">
              <span class="flex1 color21">{{item.coverName}}</span>
              <span class="moneyColor size16" v-if="item.offeDetailAmout">￥{{ item.offeDetailAmout }}</span>
              <span v-if="item.dutys"  @click="isShowFn(i,item.isShow)" class=" pointer marLeft20 color99 size12">{{ item.isShow ? '收起' : '展开' }}
                    <i class="iconfont size14" :class="item.isShow?'icongengduo-copy':'icongengduo-copy-copy'"></i>
              </span>
            </div>
            <div v-if="item.dutys && item.isShow" class="backF5 borderRadius4 paddTop4 paddBott12">
              <div class="marTop4  color66 lastTxt flex" v-for="(duty, childI) in JSON.parse(item.dutys)" :key="`child${childI}`"><span class="flex1" :class="duty.dutyAttribute =='small_tag' ? 'font600 color21': ''">{{ duty.dutyName }}</span><span class="marLeft20"  v-if="duty.dutyAttribute !='small_tag'">{{duty.amount}}{{duty.dutyUnit ? duty.dutyUnit : '元'}}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="paddTop14 borderTopF5 paddBott10" v-if="quoteVehicleInfo.confirmQuotation.smallPrice">
        <div class="XsbYcenter">
          <span class="size16 font600">小微险</span>
          <span class="moneyColor">￥{{quoteVehicleInfo.confirmQuotation.smallPrice}}</span>
        </div>
        <div v-for="(item,i) in quoteVehicleInfo.confirmQuotation.vehicleCoverVOLs" :key="i">
          <div v-if="item.className && item.coverType == 'P_04'" class="size14">
            <div class="paddTop10 flex lineH20">
              <span class="flex1 color21">{{item.coverName}}</span>
              <span class="moneyColor size16" v-if="item.offeDetailAmout">￥{{ item.offeDetailAmout }}</span>
              <span v-if="item.dutys"  @click="isShowFn(i,item.isShow)" class=" pointer marLeft20 color99 size12">{{ item.isShow ? '收起' : '展开' }}
                    <i class="iconfont size14" :class="item.isShow?'icongengduo-copy':'icongengduo-copy-copy'"></i>
              </span>
            </div>
            <div v-if="item.dutys && item.isShow" class="backF5 borderRadius4">
              <div class="marTop4  color66 lastTxt flex" v-for="(duty, childI) in JSON.parse(item.dutys)" :key="`child${childI}`"><span class="flex1">{{ duty.dutyName }}</span><span v-if="duty.amount" class="marLeft20">{{duty.amount}}元</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="paddTop14 borderTopF5 paddBott10" v-if="quoteVehicleInfo.confirmQuotation.unforeseenPrice">
        <div class="XsbYcenter">
          <span class="size16 font600">驾乘人员意外险</span>
          <span class="moneyColor">￥{{quoteVehicleInfo.confirmQuotation.unforeseenPrice}}</span>
        </div>
        <div v-for="(item,i) in quoteVehicleInfo.confirmQuotation.vehicleCoverVOLs" :key="i">
          <div v-if="item.coverType == 'P_05'" class="size14">
            <div class="paddTop10 flex lineH20">
              <span class="flex1 color21">{{item.coverName}}</span>
              <span class="moneyColor size16" v-if="item.offeDetailAmout">￥{{ item.offeDetailAmout }}</span>
              <span v-if="item.dutys"  @click="isShowFn(i,item.isShow)" class=" pointer marLeft20 color99 size12">{{ item.isShow ? '收起' : '展开' }}
                    <i class="iconfont size14" :class="item.isShow?'icongengduo-copy':'icongengduo-copy-copy'"></i>
              </span>
            </div>
            <div v-if="item.dutys && item.isShow" class="backF5 borderRadius4">
              <div class="marTop4  color66 lastTxt flex" v-for="(duty, childI) in JSON.parse(item.dutys)" :key="`child${childI}`"><span class="flex1">{{ duty.dutyName }}</span><span v-if="duty.amount" class="marLeft20">{{duty.amount}}元</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="paddTop14 borderTopF5 paddBott10" v-if="quoteVehicleInfo.quoteStatus == 11 && quoteVehicleInfo.confirmQuotation.otherAmount && quoteVehicleInfo.policyInfoVO.otherProduct">
        <p class="size16 font600 paddBott6">保单号</p>
        <div class="lastTxt marTop4 backF5 color66 textSelectAll" v-for="(item,i) in otherProduct" :key="i"> {{item.policyNo}}</div>
        <!--<van-row v-for="(item,i) in JSON.parse(quoteVehicleInfo.policyInfoVO.otherProduct)" :key="item">-->
          <!--{{item.policyNo}}<span v-if="i<JSON.parse(quoteVehicleInfo.policyInfoVO.otherProduct).length-1">，</span>-->
        <!--</van-row>-->
      </div>

    </div>
    <div class="backF marLR10 paddLR10 paddBott10 borderRadius8 overflowHidden marTop10" v-if="specialList.length > 0">
      <div class="paddTop14 XsbFlex " ><span class="size16 font600">特别约定</span><span class="pointer color99 size14" @click="specialBool = !specialBool">{{specialBool ? '收起' : '展开' }} <i class="van-icon" :class="specialBool ? 'van-icon-arrow-up':'van-icon-arrow-down'"></i></span></div>
      <div class="overflowHidden" v-if="specialBool">
        <div class="backF5 padd10 marTop10 borderRadius4 size14 specialList" v-if="specialList.filter( item => item.riskType == 2).length > 0">
          <h3 class="color99">商业险特约名称</h3>
          <div class="marTop10 overflowHidden borderBotF" v-for="(item,i) in specialList" :key="i"  v-if="item.riskType == 2">
            <h3 class="color21">{{item.clauseName}}</h3>
            <p class="color66 paddTop6 paddBott10 lineH20">{{item.conText}}</p>
          </div>
        </div>
        <div class="backF5 padd10 marTop10 borderRadius4 size14 specialList" v-if="specialList.filter( item => item.riskType == 1).length > 0">
          <h3 class="color99">交强险特约名称</h3>
          <div class="marTop10 overflowHidden borderBotF" v-for="(item,i) in specialList" :key="i"  v-if="item.riskType == 1">
            <h3 class="color21">{{item.clauseName}}</h3>
            <p class="color66 paddTop6 paddBott10 lineH20">{{item.conText}}</p>
          </div>
        </div>
      </div>
    </div>



    <div class="marLR10 padd10 borderRadius8 overflowHidden size14 backF marTop10" v-if="(channelConfig.displayDeliverInfo || channelConfig.diplayBankInfo || channelConfig.displayAlipayInfo || channelConfig.displayJobNumber) && quoteVehicleInfo.quoteVehicleExtraVO">
      <h3 class="size16 color21 font600 paddBott10 lineH20 borderBotF5">保单配送信息</h3>
      <ul class="infoList color21 paddBott10" v-if="channelConfig.displayDeliverInfo">
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">名称</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.name}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">手机号</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.tel}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">地址</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.address}}</span>
        </li>
      </ul>
      <!--TODO 银行账户信息 设计图没有-->
      <ul class="infoList color21 paddBott10" v-if="channelConfig.diplayBankInfo">
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">户名</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.payee}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">手机号</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.payeeTel}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">身份证号</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.payeeIdNo}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">银行卡号</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.bankNo}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">开户行</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.bankSubBranch}}</span>
        </li>
      </ul>
      <ul v-if="channelConfig.displayAlipayInfo">
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">支付宝名称</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.zfbName}}</span>
        </li>
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">支付宝账号</span>
          <span class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.zfbId}}</span>
        </li>
      </ul>
      <ul v-if="channelConfig.displayJobNumber">
        <li class="flex marTop10">
          <span class="color66 width100 marRight4">员工工号</span>
          <sapn class="flex1">{{quoteVehicleInfo.quoteVehicleExtraVO.jobNumber?quoteVehicleInfo.quoteVehicleExtraVO.jobNumber:'新员工'}}</sapn>
        </li>
      </ul>
    </div>
    <!--<Loading :isShow="isViewLoading"></Loading>-->
    <div class="blank60"></div>
    <foot-tab :buttText="buttText" :isCancelQuote="isCancel" :isHome="true" @tabClick="tabClick"></foot-tab>

    <van-dialog v-model="doubleCheckBool" :title="doubleCheckType == 3 ? `投保人验证`:`投保人双录验证`" :show-confirm-button="false" close-on-click-overlay>
      <div class="padd10 overflowHidden">
        <p class="size14 lineH20" v-if="doubleCheckType == 3">请输入投保人交费实名认证验证码</p>
        <p class="size14 lineH20" v-else>应深圳保监局要求，需对投保人进行双录及交费实名制</p>
        <p v-if="doubleCheckType == 2" class="size14 lineH20 marTop10">双录处理中，请稍候...</p>
        <div class="size14 lineH20 color21 marTop10 font600 colorE7" v-if="doubleCheckType != 3">{{tipMsg}}</div>
        <van-field
          class="color21 borderBotF5"
          v-if="doubleCheckType == 1"
          v-model="tel"
          icon-prefix="iconfont"
          left-icon="iconfont iconbangdingshouji themeColor size34"
          placeholder="请输入手机号"
        />
        <van-field
          class="color21 borderBotF5"
          v-if="doubleCheckType == 3"
          v-model="verifyCode"
          icon-prefix="iconfont"
          left-icon="iconfont iconyanzhengma1 themeColor size34"
          placeholder="请输入验证码"
        />
        <van-button :color="mainColor" @click="doubleCheckFn" class="borderRadius4 marTop20 widthPercent100 marBott10">确定</van-button>
      </div>
    </van-dialog>
    <van-dialog v-model="doubleCheckBool_NOURL" title="" :show-confirm-button="false" close-on-click-overlay>
      <div class="padd10 overflowHidden marLR10">
        <div class="size14 lineH20 color21 marTop10 colorE7" v-html="tipMsg_NOURL"></div>
        <van-button :color="mainColor" @click="doubleCheckBool_NOURL = false" class="borderRadius4 marTop20 widthPercent100 marBott10">确定</van-button>
      </div>
    </van-dialog>
    <van-dialog v-model="payBool" title="支付二维码" :show-confirm-button="false" close-on-click-overlay>
      <vue-qr :margin="20" colorLight="#fff" :text="payImgLink" :size="320" class="borderRadius8"></vue-qr>
      <!--<div class="payQrCode"><img :src="payImgLink" /></div>-->
    </van-dialog>
    <van-overlay :show="show" z-index="999">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="payTitle font500 size16 color33">支付</div>
          <ul class="payList" v-if="payJson && payJson.length > 0">
            <li class="flex"  v-for="(item,i) in payJson" :key="i" v-if="item.ysCurShow">
              <span class="payTypeName color21 size14">{{item.ysName}}</span>
              <div class="flex1" v-if="item.ysType =='radio' && item.ysArr && item.ysArr.length > 0">
                <van-radio-group icon-size="16px" direction="horizontal"   v-model="item.ysDefault" :disabled="item.ysDisabled">
                  <van-radio icon-size="16px" @click="radioChange(sitem,item)" class="payRdio color66 size14"  v-for="(sitem,k) in item.ysArr" :key="k" :name="sitem.value" >{{sitem.key}}<template #icon="props">
                    <img :src="props.checked ? activeIcon : inactiveIcon" style="height: 20px;"></img>
                  </template></van-radio>
                </van-radio-group>
                <div class="Yflex paddBott14" v-for="(sitem,j) in item.subArr" :key="j" v-if="item.subArr && item.subArr.length > 0 && sitem.ysCurShow">
                  <span class="color66 marRight6 size14">{{sitem.ysName}}</span>
                  <van-field class="flex1 pagyInput" v-if="sitem.ysType == 'text'" v-model.trim="sitem.ysDefault" input-align="right" :disabled="sitem.ysDisabled"/>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="payJson && payJson.length > 0" class="textCenter size14 colorE7 paddTop14 paddBott16">{{payJson[0].tips}}</div>
          <div class="bottomBtn flex size16">
            <span class="color21 pointer"  @click="show = false">取消</span>
            <span class="color40 pointer" @click="goPay">支付</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  // import Loading from "../common/Loading";
  import {record}  from 'rrweb'; // 录屏组件
  import ClipboardJS from 'clipboard'
  import footTab from '../base/footTab'
  import {baseApis} from "../../utils/mixins/baseApiMixin";
  import QuoteVehicleInfo from "../../public/QuoteVehicleInfo";//填写信息变量
  import ChannelConfig from "../../public/ChannelConfig";//渠道信息变量
  import vueQr from 'vue-qr'
  export default {
    components: {
      footTab,
      vueQr
      // Loading
    },
    mixins: [baseApis],
    data () {
      return {
        show:false,
        activeIcon: require('../../../static/images/radioCur.png'),
        inactiveIcon: require('../../../static/images/radio.png'),
        payJson:[],
        year:['','当年应缴','往年补缴','前年补缴'],
        specialBool: true,
        specialList:[], // 特别约定
        channelConfig:JSON.parse(JSON.stringify(ChannelConfig)),// TODO 渠道信息变量
        mainColor:this.$store.state.themeMainColor,
        quoteVehicleInfo:JSON.parse(JSON.stringify(QuoteVehicleInfo)),
        orderId:'',
        channelCode:'',
        // isViewLoading:false,
        buttText:'',
        backText:'',
        doubleCheckBool:false,
        doubleCheckType:'1',
        tel:'',
        verifyCode:'',
        tipMsg:'发送电子投保单确认短信给TA',
        isCancel:false,
        payBool:false,
        payImgLink:'',
        insuranceBool:true,
        jqxRenewal:'',
        syxRenewal:'',
        eventsArr:[], // 录屏数据
        isRecordScreen: false, // 是否录制
        doubleCheckBool_NOURL:false,
        tipMsg_NOURL:``,
      }
    },
    computed: {
      per: {
        get() {
          return 0;
        },
        set(val) {
          console.log(val);
        },
      },
    },
    created(){
      if(sessionStorage['channelConfig']){
        this.isRecordScreen = JSON.parse(sessionStorage['channelConfig']).isVehicleVide == 1 ? true : false
      }
      this.orderId = this.commonJs.getQueryString('orderId') || this.$route.query.orderId;
      this.channelCode = this.commonJs.getQueryString('channelCode') || this.$route.query.channelCode || sessionStorage['channelCode'];
      if(sessionStorage['channelConfig']){
        this.channelConfig = JSON.parse(sessionStorage.getItem('channelConfig'));
        this.commonJs.getLoadQuoteInfo(data=>{
          this.channelCode = data.channelCode
          this.orderId = data.orderId
          this.quoteVehicleInfo = data
          if(data.confirmQuotation){
            let obj = data.confirmQuotation
            this.specialList = obj.promiseJson ? JSON.parse(obj.promiseJson) : []
          }
          if(data.policyInfoVO && data.policyInfoVO.otherProduct){
            this.otherProduct = JSON.parse(data.policyInfoVO.otherProduct)
          }
          let totalAmount = this.quoteVehicleInfo.confirmQuotation?this.quoteVehicleInfo.confirmQuotation.totalAmount:0
          this.backText = this.commonJs.getQueryString('buttText') || this.$route.query.buttText;
          if(this.quoteVehicleInfo.quoteStatus == 11) this.backText = '返回'
          if(this.backText){
            this.buttText = this.backText
            document.title = '订单详情'
          }else{
            this.buttText = '￥'+ totalAmount+'支付'
          }
          if(data.quoteStatus == 14 && data.vehicleChkName && data.vehicleChkTel){
            this.$dialog.alert({
              title:'需要验车',
              message: `您已选择验车服务，可咨询客服人员确认验车情况，联系人${data.vehicleChkName}：<a href='tel:${data.vehicleChkTel}'>${data.vehicleChkTel}</a>`,
            }).then(() => {
            });
          }

          //撤单按钮，目前只有对接TP,DH,YT,GR,GSC,SIG，CPIC
          let quoteAccountId = this.quoteVehicleInfo.quoteAccountId
          if((this.quoteVehicleInfo.quoteStatus == 7||this.quoteVehicleInfo.quoteStatus == 5)
            &&(quoteAccountId.indexOf('TP')!=-1 || quoteAccountId.indexOf('DH')!=-1 || quoteAccountId.indexOf('GR')!=-1 || quoteAccountId.indexOf('YT')!=-1 || quoteAccountId.indexOf('GSC')!=-1 || quoteAccountId.indexOf('CPIC')!=-1 || quoteAccountId.indexOf('SIG')!=-1 )){
            this.isCancel = true;
          }
          let detailsData = data.confirmQuotation
          if (detailsData.jqxRenewalFlag !== '' && detailsData.jqxRenewalFlag !== null) {
            if (detailsData.jqxRenewalFlag == 0 || detailsData.jqxRenewalFlag == 4) {
              this.jqxRenewal = "续交";
            } else if (detailsData.jqxRenewalFlag == 1) {
              this.jqxRenewal = "新交";
            } else if (detailsData.jqxRenewalFlag == 2) {
              this.jqxRenewal = "转交";
            }
          } else {
            this.jqxRenewal = "";
          }
          if (detailsData.syxRenewalFlag !== '' && detailsData.syxRenewalFlag !== null) {
            if (detailsData.syxRenewalFlag == 0 || detailsData.syxRenewalFlag == 4) {
              this.syxRenewal = "续商";
            } else if (detailsData.syxRenewalFlag == 1) {
              this.syxRenewal = "新商";
            } else if (detailsData.syxRenewalFlag == 2) {
              this.syxRenewal = "转商";
            }
          } else {
            this.syxRenewal = "";
          }
          if(detailsData.vehicleCoverVOLs){
            let price1 = 0
            let price2 = 0
            let price3 = 0
            detailsData.vehicleCoverVOLs.map(item =>{
              if(item.coverType == 'P_04'){
                price1 = price1+item.offeDetailAmout
              }
              if(item.coverType == 'P_01' || item.coverType == 'P_02' || item.coverType == 'P_03'){
                price2 = price2+item.offeDetailAmout
              }
              if(item.coverType == 'P_05'){
                price3 = price3+item.offeDetailAmout
              }
            })
            this.quoteVehicleInfo.confirmQuotation.wealthPrice = price2 > 0 ? price2.toFixed(2) : price2; // 小微险总价
            this.quoteVehicleInfo.confirmQuotation.smallPrice= price1 > 0 ? price1.toFixed(2) : price1; // 财意险总价
            this.quoteVehicleInfo.confirmQuotation.unforeseenPrice= price3 > 0 ? price3.toFixed(2) : price3; // 驾乘人员意外险
          }
        })
      }else{
        this.commonJs.backChannelData(this.orderId,this.channelCode,data=>{
          this.channelConfig = data
          this.commonJs.getLoadQuoteInfo(data=>{
            this.channelCode = data.channelCode
            this.orderId = data.orderId
            this.quoteVehicleInfo = data
            if(data.confirmQuotation){
              let obj = data.confirmQuotation
              this.specialList = obj.promiseJson ? JSON.parse(obj.promiseJson) : []
            }
            if(data.policyInfoVO && data.policyInfoVO.otherProduct){
              this.otherProduct = JSON.parse(data.policyInfoVO.otherProduct)
            }
            let totalAmount = this.quoteVehicleInfo.confirmQuotation?this.quoteVehicleInfo.confirmQuotation.totalAmount:0
            this.backText = this.commonJs.getQueryString('buttText') || this.$route.query.buttText;
            if(this.quoteVehicleInfo.quoteStatus == 11) this.backText = '返回'
            if(this.backText){
              this.buttText = this.backText
              document.title = '订单详情'
            }else{
              this.buttText = '￥'+ totalAmount+'支付'
            }
            if(data.quoteStatus == 14 && data.vehicleChkName && data.vehicleChkTel){
              this.$dialog.alert({
                title:'需要验车',
                message: `您已选择验车服务，可咨询客服人员确认验车情况，联系人${data.vehicleChkName}:<a href='tel:${data.vehicleChkTel}'>${data.vehicleChkTel}</a>`,
              }).then(() => {
              });
            }
            //撤单按钮，目前只有对接TP,DH,YT,GR,GSC,SIG，CPIC
            let quoteAccountId = this.quoteVehicleInfo.quoteAccountId
            if((this.quoteVehicleInfo.quoteStatus == 7||this.quoteVehicleInfo.quoteStatus == 5)
              &&(quoteAccountId.indexOf('TP')!=-1 || quoteAccountId.indexOf('CPIC')!=-1  || quoteAccountId.indexOf('DH')!=-1 || quoteAccountId.indexOf('GR')!=-1 || quoteAccountId.indexOf('YT')!=-1 || quoteAccountId.indexOf('GSC')!=-1 || quoteAccountId.indexOf('SIG')!=-1 )){
              this.isCancel = true;
            }
            let detailsData = data.confirmQuotation
            if (detailsData.jqxRenewalFlag !== '' && detailsData.jqxRenewalFlag !== null) {
              if (detailsData.jqxRenewalFlag == 0 || detailsData.jqxRenewalFlag == 4) {
                this.jqxRenewal = "续交";
              } else if (detailsData.jqxRenewalFlag == 1) {
                this.jqxRenewal = "新交";
              } else if (detailsData.jqxRenewalFlag == 2) {
                this.jqxRenewal = "转交";
              }
            } else {
              this.jqxRenewal = "";
            }
            if (detailsData.syxRenewalFlag !== '' && detailsData.syxRenewalFlag !== null) {
              if (detailsData.syxRenewalFlag == 0 || detailsData.syxRenewalFlag == 4) {
                this.syxRenewal = "续商";
              } else if (detailsData.syxRenewalFlag == 1) {
                this.syxRenewal = "新商";
              } else if (detailsData.syxRenewalFlag == 2) {
                this.syxRenewal = "转商";
              }
            } else {
              this.syxRenewal = "";
            }
            if(detailsData.vehicleCoverVOLs){
              let price1 = 0
              let price2 = 0
              detailsData.vehicleCoverVOLs.map(item =>{
                if(item.coverType == 'P_04'){
                  price1 = price1+item.offeDetailAmout
                }
                if(item.coverType == 'P_01' || item.coverType == 'P_02' || item.coverType == 'P_03'){
                  price2 = price2+item.offeDetailAmout
                }
              })
              this.quoteVehicleInfo.confirmQuotation.wealthPrice = price2 // 小微险总价
              this.quoteVehicleInfo.confirmQuotation.smallPrice= price1 // 财意险总价
            }
          })
        })
      }
    },
    mounted(){
      if(this.isRecordScreen){
        this.initRRWeb()
      }
    },
    methods: {
      radioChange(item,obj) {
        const associatedLabel = item.associatedLabel || ''
        const associatedKey = item.associatedKey || ''
        let arr = this.payJson
        if(item.hasOwnProperty('associatedLabel')){
          console.log(`associatedLabel:${associatedLabel}`)
          arr.map(item => {
            if(item.labelId == associatedLabel){
              item.ysCurShow = true
            }else{
              item.ysCurShow = item.ysIsShow
            }
          })
        }
        if(item.hasOwnProperty('associatedKey')){
          console.log(`associatedKey:${associatedKey}`)
          if(obj.subArr && obj.subArr.length > 0){
            obj.subArr.map(item => {
              if(item.parentKey == associatedKey){
                item.ysCurShow = true
              }else{
                item.ysCurShow =  item.ysIsShow
              }
            })
          }
          arr.map(item => {
            if(item.labelId == obj.labelId){
              item = obj
            }
          })
        }
        this.$set(this.payJson,arr);
        console.log(this.payJson)
      },
      goPay(){
        let obj = this.mapList(this.payJson,{})
        if(obj.hasOwnProperty('isNext')) return false // 如果有必填字段为空 不往下走
        this.getPayUrl('',obj)
        this.show = false
      },
      mapList(arr,obj){
        arr.some((item) => {
          if(item.ysCurShow && item.ysRequired == 'noEmpty' && !item.ysDefault){
            this.$toast(`请录入或选择${item.ysName}`)
            obj.isNext = true // 用来判读是不是必填字段为空
            return false
          }
          if(item.ysCurShow && item.ysDefault){
            obj[item.ysField] = item.ysDefault
            if(item.subArr && item.subArr.length > 0){
              this.mapList(item.subArr,obj)
            }
          }
        })
        return obj
      },

      // 展开责任
      isShowFn(i,isShow){
        let bool = isShow?false:true
        this.$set(this.quoteVehicleInfo.confirmQuotation.vehicleCoverVOLs[i],'isShow',bool)
      },
      tabClick(type,status){

        if(status == 1){
          if(this.isRecordScreen){
            this.savaWeb('home',this.channelCode)
          }else {
            this.$router.push({path:`/home`,query:{channelCode:this.channelCode}})
          }
        }else if(status == 3){
          if(this.backText){
            if(this.isRecordScreen){
              this.savaWeb('myOrder',this.channelCode)
            }else {
              this.$router.push({path:`/myOrder`,query:{channelCode:this.channelCode}})
            }
          }else{

            this.getPayUrl()
          }
        }else if(status == 11){
          this.$dialog.confirm({
            message: '请确认是否撤单？',
          }).then(() => {
            let params = {
              orderId: this.quoteVehicleInfo.orderId,
              productCode: this.quoteVehicleInfo.confirmOpCode,
              thirdInsuranceId: this.quoteVehicleInfo.quoteAccountId
            }
            this.$http.post('/vehicle/cancelVehicleQuote', params).then(res => {
              if (!res) return
              let data = res.data.body;

              if(data=="success"){
                if(this.isRecordScreen){
                  this.savaWeb('insuranceInformation',this.quoteVehicleInfo.orderId)
                }else {
                  this.$router.push({path: '/insuranceInformation', query: {"orderId":this.quoteVehicleInfo.orderId}}) //填写信息
                }

              }else{
                this.$dialog.alert({
                  title:'提示',
                  message: `无法撤单，请联系业务员`,
                }).then(() => {
                });
              }

            })
          }).catch(() => {
            // on cancel
          });
        }


        // this.$router.push('/myOrder')
      },
      // 双录验证弹窗
      doubleCheckFn(){
        if(this.tel || this.verifyCode) {
          if(this.doubleCheckType == 1){
            // 输入手机号   发送太平双录链接
            this.$http.post('/vehicle/tpSendTpDouble',{orderId:this.orderId,tel:this.tel}).then(res=>{
              if(!res) return
              this.doubleCheckBool = false
            })
          }else if(this.doubleCheckType == 2){
            this.doubleCheckBool = false
          }else if(this.doubleCheckType == 3){
            this.getPayUrl(this.verifyCode)
          }
        }else{
          let errorMsg = this.doubleCheckType == 1?'请输入手机号':'请输入验证码'
          this.$toast(errorMsg);
        }

      },
      // 获取支付链接
      getPayUrl(verifyCode,payExtend){
        let params = {
          orderId:this.orderId
        }
        if(verifyCode){
          params.verifyCode = verifyCode
        }
        if(payExtend){
          params.payExtend = `${JSON.stringify(payExtend)}`
        }
        this.doubleCheckBool = false
        this.$http.post('/vehicle/getPayUrl',params).then(res=>{
          if(!res) return
          let data = res.data.body
          if(this.isRecordScreen){
            this.savaWeb()
          }
          if(data.payType == 'DOUBLE_INFO'){
            this.doubleCheckBool = true
            this.doubleCheckType = 1
          }else if(data.payType == 'FAIL_MSG'){
            this.$dialog.alert({
              message: `${data.msg}`,
            }).then(() => {});
          }else if(data.payType == 'PAY_SUCCESS'){
            this.$dialog.alert({
              message: `该单已成功支付!`,
            }).then(() => {});
          } else if(data.payType == 'SUCCESS'){
            let url = data.syxPayUrl || data.jqxPayUrl
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              window.location.href = url
            } else {
              window.open(url,"_blank");
            }
          }else if(data.payType == 'QRCODE' || data.payType == 'IMG'){
            this.$router.push({path: '/pay', query: {orderId: this.orderId}})
          }else if(data.payType == 'SEND_INFO'){
            this.doubleCheckBool = true
            this.doubleCheckType = 3
          }else if(data.payType == 'NO_URL'){
            this.doubleCheckBool_NOURL = true
            this.tipMsg_NOURL = data.msg
          }
          else if(data.payType == 'PAY_EXTEND'){
            this.show = true
            this.payJson = JSON.parse(data.msg)

          }

            //处理太平获取请求链接显示错误
//          if(data && data.indexOf("http")>-1){
//            window.location.href = data;
//          }else if(data.includes('data:image')){
//            this.payImgLink = data
//            this.payBool = true
//          }else{
//
//          }

        })
      },


      copyFn(val) {
        let _this = this
        let btn = `#${val}`
        let clipboard = new ClipboardJS(btn);
        clipboard.on("success", function (e) {
          _this.$toast(`复制到粘贴板`);
          e.clearSelection();
          clipboard.destroy()
        });
        clipboard.on("error", function (e) {
          _this.$toast(`复制失败`);
          e.clearSelection();
        });
      },
      initRRWeb() {
        let events = [];
        record({
          emit (event) {
            // 用任意方式存储 event
            events.push(event);
          }
        })
        this.eventsArr = events   // 完整一个阶段的数据
      },
      async savaWeb(next,channelCode) {
        //      {
        //        "channelCode": "string", // 货架编号
        //        "orderNo": "string", // 订单号
        //        "productId": "string", //产品ID
        //        "recallId": 0, //回溯ID
        //        "recallStatus": 0, //回溯状态：1-采集中、2-采集完成
        //        "source": 0, //来源：1-H5、2-PC端
        //        "step": 0, //当前步骤：1-信息查询、2-资料填写、3-险种选择、4-报价、5-核保、6-投保结果
        //        "version": "string", //版本号
        //        "video": "string" //视频对象
        //         isType : 1-车险 2-非车 // 可回溯类型
        //      }
        let eventsArr = this.eventsArr
        let eventstr = JSON.stringify(eventsArr)
        //api/recallRecord/save/recallRecord
        let params = {
          channelCode: sessionStorage['channelCode'] || '',
          orderId: sessionStorage['orderId'] || '',
          orderNo: sessionStorage['orderNo'] || '',
          userId: JSON.parse(localStorage['userData']).userInfoVO.userInfoId,
          recallId: sessionStorage['recallId'] || '',
          recallStatus:1,
          source:1,
          step:6,
          version: 1, // 写死传1
          isType:1,
          video:eventstr
        }
        await this.$http.post('/recallRecord/save/recallRecord',params).then(res=>{
          if(!res) return
          let url = ``
          if(next){
            switch(next) {
              case 'insuranceInformation':
                url = `${location.origin}/hv2/insuranceInformation?orderId=${channelCode}` // 信息填写
                break;
              case 'home':
                url = `${location.origin}/hv2/home?channelCode=${channelCode}` // 首页
                break;
              case 'myOrder':
                url = `${location.origin}/hv2/myOrder?channelCode=${channelCode}` //订单
                break;
            }
            window.location.href = url
          }
        })
      },

    },

  }
</script>

<style scoped>
.infoList,.infoList li{
  overflow:hidden;
}
.infoList li{
  line-height:20px;
}
.lastTxt{
  padding:4px 10px;
  line-height:20px;
}
  .payQrCode{
    width:280px;
    height:280px;
    margin:20px;
    background:#fff;
    overflow:hidden;
    border-radius:4px;
  }
.payQrCode img{
  width:280px;
  height:280px;
  float: left;
  object-fit: cover;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 90%;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.payTitle{
  overflow: hidden;
  text-align:center;
  border-bottom:1px solid #F0F0F0;
  line-height: 45px;
}
.bottomBtn{
  overflow: hidden;
  width:100%;
  border-top:1px solid #F0F0F0;
  text-align:center;
}
.bottomBtn span{
  width: 50%;
  height:46px;
  line-height: 46px;
}
.bottomBtn span:last-child{
  border-left: 1px solid #F0F0F0;
}
.payList{
  overflow-x:hidden;
  padding: 0 12px;
  max-height: 55vh;
}
.payList li {
  padding-top:14px;
  overflow: hidden;
  border-top:1px solid #F0F0F0;
}
.payList li:first-child{
  border-top:none;
}
.payTypeName{
  padding: 0 10px 0 4px;
  width: 76px;
  overflow: hidden;
}
.payRdio{
  overflow: hidden;
  min-width: 110px;
  padding-bottom: 14px;
}
.pagyInput{
  overflow: hidden;
  border: thin solid #ccc;
  border-radius: 4px;
  padding: 5px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/insuranceInformation/confirmTheInsured.vue